import Swal from 'sweetalert2';
import Table from '../components/Table';
import Spinner from '../components/utilities/Spinner';
import BuildApiUrl from '../components/tables/BuildApiUrl';
import AddRowClickLinks from '../components/tables/AddRowClickLinks';
import AddRowDataAttrs from '../components/tables/AddRowDataAttrs';
import GetCols from '../components/tables/GetCols';
import ToastCustom from '../components/alerts/ToastCustom';
import ActionsMenu from '../components/tables/ActionsMenu';
import {PollProgress} from '../components/tables/PollProgress';
import FirstFour from '../components/tables/FirstFour';
import BuildTrendChart from '../components/tables/BuildTrendChart';

// Bulk actions
import CreateBulk from '../components/tables/bulk_actions/CreateBulk';
import DeleteBulk from '../components/tables/bulk_actions/DeleteBulk';
import DisableBulk from '../components/tables/bulk_actions/DisableBulk';
import MergeBulk from '../components/tables/bulk_actions/MergeBulk';
import UpdateBulk from '../components/tables/bulk_actions/UpdateBulk';
import GetBulk from '../components/tables/bulk_actions/GetBulk';
import ExportBulk from '../components/tables/bulk_actions/ExportBulk';

// Checkbox actions
import ShowHeaderButtons from '../components/tables/checkboxes/ShowHeaderButtons';
import HideHeaderButtons from '../components/tables/checkboxes/HideHeaderButtons';
import ToggleCheckbox from '../components/tables/checkboxes/ToggleCheckbox';
import SelectDisplayedCheckboxes from '../components/tables/checkboxes/SelectDisplayedCheckboxes';

export default class {

  constructor(el) { this.el = el; }

  getData() {

    // Set table element id
    const tableId = this.el.attr('id');

    // Build url
    const url = BuildApiUrl(tableId);

    // Get data
    return $.getJSON(url);
  }


  render() {

    // Set table id
    const tableId = this.el.attr('id');

    // Build url, use to get filtered data with server-side processing
    let dataUrl = BuildApiUrl(tableId);

    // Set additional data vars (used below in table creation)
    let cols = GetCols(this.el);

    // Avoid forcing container height; let the table body handle scrolling.
    let $container = this.el.closest('.TableContainer');

    const computeAutoScrollHeight = () => {
      if ($container.length === 0) {
        return null;
      }

      const containerRect = $container[0].getBoundingClientRect();
      const footerHeight = $container.find('.TableFooter').outerHeight(true) || 0;
      const headerHeight = $container.find('thead').outerHeight(true) || 0;
      const padding = 24;
      const available = window.innerHeight - containerRect.top - footerHeight - headerHeight - padding;
      return available > 200 ? Math.floor(available) : null;
    };

    const updateHorizontalScrollState = () => {
      if ($container.length === 0) {
        return;
      }

      const scrollBody = $container.find('.dataTables_scrollBody')[0];
      if (!scrollBody) {
        return;
      }

      const overflow = scrollBody.scrollWidth - scrollBody.clientWidth;
      const tolerance = 20;
      const hasOverflow = overflow > tolerance;
      const bodyTable = scrollBody.querySelector('table');
      const headTable = $container.find('.dataTables_scrollHeadInner table')[0];

      scrollBody.classList.toggle('has-x-scroll', hasOverflow);
      if (hasOverflow) {
        if (bodyTable) {bodyTable.style.width = '';}
        if (headTable) {headTable.style.width = '';}
        return;
      }

      if (bodyTable) {bodyTable.style.width = '100%';}
      if (headTable) {headTable.style.width = '100%';}
      scrollBody.scrollLeft = 0;
    };

    // Only enable DataTables scrolling when a height is explicitly provided.
    let scrollY = $container.attr('data-scroll-height');
    if (typeof scrollY === 'undefined') {scrollY = $('#' + tableId).attr('data-scroll-height')}
    if (typeof scrollY === 'undefined') {scrollY = null}
    if (scrollY === null) {
      const autoScroll = computeAutoScrollHeight();
      scrollY = autoScroll ? `${autoScroll}px` : null;
    }

    // Page length
    let pageLength = this.el.attr('data-page-length');
    if (typeof pageLength === 'undefined') {pageLength = 50}

    // Paging
    let paging = this.el.attr('data-paging');
    if (typeof paging === 'undefined') {paging = true}

    // Server side (defaults to true)
    let serverSide = this.el.attr('data-server-side');
    if (typeof serverSide === 'undefined') {serverSide = true}

    // Ajax method (POST avoids query string length limits for wide tables)
    let ajaxMethod = this.el.attr('data-ajax-method');
    if (typeof ajaxMethod === 'undefined') {ajaxMethod = 'GET'}

    // Sort order
    let orderCol = this.el.attr("data-order-col");
    if (typeof orderCol === 'undefined') {orderCol = 0;}
    let orderDir = this.el.attr('data-order-dir');
    if (typeof orderDir === 'undefined') {orderDir = 'asc'};

    // Set fixed columns
    let leftFixed = this.el.attr("data-left-fixed");
    if (typeof leftFixed === 'undefined') {leftFixed = 1;}

    // Set no data message
    let noDataMessage = this.el.attr('data-no-data-message');
    let defaultMessage = 'Nothing found. Reach out to us at success@ethosesg.com if you would like any help.';
    if (typeof noDataMessage === 'undefined') {noDataMessage = defaultMessage}

    // Set dom
    let dom = "t";

    // Set data structure to store recordIds throughout pagination and other actinos
    $('#' + tableId).data('record-ids', []);


    // Render table
    // Responsive - details: false - don't show hidden details on small devices 
    // (https://datatables.net/reference/option/responsive)
    // Use 'retrieve' to avoid reinitialization error (https://datatables.net/manual/tech-notes/3)
    const table = $('#' + tableId).DataTable({
      retrieve: true,
      serverSide: serverSide,
      ajax: { url: dataUrl, type: ajaxMethod, beforeSend: function(xhr) { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')); } },

      scrollY: scrollY,
      scrollX: true,
      deferRender: true,
      scrollCollapse: !!scrollY,
      fixedColumns: {leftColumns: leftFixed, rightColumns: 0},
      paging: paging,
      pageLength: pageLength,
      searching: true,
      order: [[orderCol, orderDir]],
      dom: dom,
      columns: cols,
      responsive: { details: false },
      language: { 
        lengthMenu: "Show _MENU_ records",
        infoEmpty: noDataMessage,
        emptyTable: noDataMessage,
        zeroRecords: noDataMessage
      },
      createdRow(row, data, dataIndex) {

        // Add data attrs to row
        AddRowDataAttrs(row, data);

      },

      drawCallback: function( settings ) {

        // Remove loading
        let tableContainer = $('#' + tableId).closest('.TableContainer')

        // Set current page in pagination typeahead
        let oTable = $('#' + tableId).DataTable();
        if ((typeof oTable !== 'undefined') && (typeof oTable.page.info() !== 'undefined')) {
          let currentPage = oTable.page.info().page;
          $(tableContainer).find('.pageSelect').typeahead('val', currentPage + 1);

          // Add paging info as data attr to table
          if (typeof settings.json !== 'undefined') {
            let tot = settings.json.recordsTotal;
            let filteredCount = settings.json.recordsFiltered;
            let recordLength = settings.json.data.length;
            let pageLength = oTable.page.info().length;
            let start = (currentPage * pageLength) + 1;
            let end = Math.min(tot, (currentPage + 1) * pageLength);
            if (recordLength >= tot) {
              $(tableContainer).find('.TotalRecords').addClass('d-none');
              $(tableContainer).find('.pagination').addClass('d-none');
            } else {          
              $(tableContainer).find('.TotalRecords').removeClass('d-none');
              $(tableContainer).find('.pagination').removeClass('d-none');
              $(tableContainer).find('.displayedRecords').empty().append(start + ' - ' + end);
              $(tableContainer).find('.totalRecords').empty().append(tot.toLocaleString("en"));
            }
          }

        }

        // If option to preselect
        if ($('#' + tableId).attr('data-preselect-all') === 'true') {
          
          // Select all checkboxes
          SelectDisplayedCheckboxes(tableId);

          // Remove option to select all
          $('#selectAllData').remove();

        }

        // If any records marked as checked
        let checkedRecordIds = $('#' + tableId).data('record-ids');
        if (typeof checkedRecordIds !== 'undefined') {
          $.each(checkedRecordIds, function(i,v) {
            let checkBox = $('tr[data-record-id=\'' + v + '\'').find('.checkbox');
            checkBox.prop('checked', true);
            ToggleCheckbox(checkBox, tableId);
          })
        }

        // Unhide footer title if present
        $(tableContainer).find('.FooterTitle').removeClass('d-none');

        // Re-init tooltips
        $('[data-toggle=tooltip]').tooltip({
          delay: {
            show: 800,
            hide: 100
          }
        });

        // Update sort carets
        let lastSort = settings.aLastSort[0]
        if (typeof lastSort !== 'undefined') {
          let sortCol = lastSort.col + 1;
          let sortDir = lastSort.dir;
          let sortHead = $('thead th:nth-child(' + sortCol + ')');
          $('.sort-arrows:not(.sort-none)').addClass('d-none');
          $('.sort-arrows.sort-none').removeClass('d-none');
          sortHead.find('.sort-arrows.sort-none').addClass('d-none');
          if (sortDir === "asc") {
            sortHead.find('.sort-arrows.sort-asc').removeClass('d-none');
          } else {
            sortHead.find('.sort-arrows.sort-desc').removeClass('d-none');
          }
        }

        // Dropdown actions menu on each row
        ActionsMenu(tableId);

        // Select displayed cells
        $('.select-displayed-cells').off().on('click', function() {
          if (this.checked) {
            SelectDisplayedCheckboxes(tableId);
          } else {
            HideHeaderButtons(tableId);
          }
        });

        // Checkbox check on check
        $('#' + tableId).find('.checkbox').change(function() {
          let recordId = $(this).closest('tr').attr('data-record-id');
          $('#' + tableId).data('record-ids').push(recordId);
          ToggleCheckbox($(this), tableId);
        });

        // On toggle 
        $('#' + tableId).find('.custom-control-input').change(function() {
          if ($(this).is(":checked")) {
            let url = $(this).attr('data-create-url');
            $.ajax({
              type: 'POST',
              dataType: 'application/json',
              url: url
            });
          } else {
            let url = $(this).attr('data-delete-url');
            $.ajax({
              type: 'DELETE',
              dataType: 'application/json',
              url: url
            });
          }          
        })

        // Auto-update fields on blur
        $('#' + tableId).find('.auto-update').on('blur', function() {
          let val = $(this).val();
          let url = $(this).data('api-url');
          let method = $(this).data('method');
          let params = {}
          let param = $(this).data('param');
          params[param] = val;
          url = url + '?' + $.param(params);
          $.ajax({
            type: method,
            dataType: 'application/json',
            url: url,
            complete() {

              // Sum all .auto-update input values
              let tot = 0;
              $('.auto-update').each(function() {
                let v = parseFloat($(this).val());
                if (!isNaN(v)) tot += v;
              });

              // Display as rounded percentage (0-100)
              let percent = Math.round(tot * 100);
              if ($('.table-total').length > 0) {
                $('.table-total').empty().append(percent + '%');
              }

            }
          });
        })

        // Dropdowns for bulk actions
        $('.BulkActionDropdown .toggleDropdown').off().on('click', function(e) {
          e.preventDefault();
          $(this).closest('.BulkActionDropdown').toggleClass('show');
        });

        $('body').on('click', function (e) {
          let d = $('.BulkActionDropdown');
          if ( !d.is(e.target) && d.has(e.target).length === 0 && $('.show').has(e.target).length === 0) {
            d.removeClass('show');
          }
        });

        // Bulk actions
        CreateBulk(tableId);
        DeleteBulk(tableId);
        DisableBulk(tableId);
        MergeBulk(tableId);
        UpdateBulk(tableId);
        ExportBulk(tableId);
        GetBulk(tableId);

        // Poll for updated record status if there's a progress bar
        let inProgress = $('.table .ethos-progress-bar');
        if (inProgress.length !== 0) {
          $.each(inProgress, function(i, el) {
            setTimeout(function() {
              PollProgress(el, tableId);
            }, 4000);
          })
        }

        // Set table cells to align right if headers set as align right
        $('#' + tableId + ' th.text-right').each(function() {
          let index = $(this).index() + 1;
          let td = $('#' + tableId + ' td:nth-child(' + index + ')')
          td.addClass('text-right');
          td.find('.d-flex').removeClass('justify-content-start, justify-content-center').addClass('justify-content-end');
        })

        // Fill first 4 boxes if present on page
        FirstFour(settings);

        // Fill benchmark data if present on page
        let benchmarkData = $('#benchmarkData');
        if (benchmarkData.length !== 0) {
          let passedBenchData = settings.json.benchmark_data;
          $('#benchmarkData').empty().append(passedBenchData);
        }

        // Remove records if have conditional display options
        if ($('#' + tableId).hasClass('conditional-display')) {
          $.each(settings.json.data, function(i, d) {
            let shouldDisplay = d.should_display;
            if (shouldDisplay === false) {
              $('#' + tableId).find('tr[data-record-id=\'' + d.record_id + '\']').remove();
            }
          })
        }

        updateHorizontalScrollState();


      }, initComplete: function( settings ) {

        // Set table
        let oTable = $('#' + tableId).DataTable();
        let tableContainer = $('#' + tableId).closest('.TableContainer')

        if (scrollY) {
          const updateScrollBodyHeight = () => {
            const autoScroll = computeAutoScrollHeight();
            if (!autoScroll) {
              return;
            }
            const body = $(tableContainer).find('.dataTables_scrollBody');
            body.css('height', `${autoScroll}px`);
            body.css('max-height', `${autoScroll}px`);
          };

          updateScrollBodyHeight();
          $(window).off(`resize.table-${tableId}`).on(`resize.table-${tableId}`, updateScrollBodyHeight);
        }

        updateHorizontalScrollState();
        $(window).off(`resize.table-${tableId}-x`).on(`resize.table-${tableId}-x`, updateHorizontalScrollState);

        // Hide loader; must be after init is complete to ensure all data is rendered
        $(tableContainer).removeClass('loading');
        $(tableContainer).find('.TableLoading').remove();

        // Set footer if present
        let footerHeaders = tableContainer.find('.dataTables_scrollFoot tfoot th');
        let footerData = settings.json.footer;
        if ((typeof footerData !== 'undefined') && (footerHeaders.length !== 0)) {
          $.each(footerHeaders, function(i, h) {
            let name = $(h).attr('data-name');
            let d = footerData[name];
            if (typeof d !== 'undefined') {$(this).empty().append(d)}
          })
        }

        // Add paging info as data attr to table
        let tot = settings.json.recordsTotal;
        let pageLength = $('#' + tableId).attr('data-page-length');
        if (typeof pageLength === 'undefined') {pageLength = 50}
        let pages = Math.ceil((tot / pageLength).toFixed(2));
        let listOptions = [];
        let i = 1;
        while (i <= pages) {
          listOptions.push(i);
          i++;
        }

        // Match page number on search
        var substringMatcher = function(strs) {
          return function findMatches(q, cb) {
            let matches = [];
            let substrRegex = new RegExp(q, 'i');
            $.each(strs, function(i, str) {
              if (substrRegex.test(str)) {
                matches.push(str);
              }
            });
            cb(matches);
          };
        };

        // Build trend line if present
        BuildTrendChart(settings);

        // If only one page, disable paging
        if (pages === 0) {
          $(tableContainer).find('.pageSelect').addClass('disabled').attr('disabled', true);
          $('.page-left').addClass('disabled');
          $('.page-right').addClass('disabled');

        } else {

          // Select / search for page number
          $(tableContainer).find('.pageSelect').typeahead({
            hint: true,
            highlight: true,
            minLength: 0
          },{
            name: 'list',
            limit: 554,
            source: substringMatcher(listOptions)
          });

          // On selecting a page
          $(tableContainer).find('.pageSelect').bind('typeahead:beforeselect', function(ev, suggestion) {

            // Remove hidden header buttons and preselect option
            $('#' + tableId).attr('data-preselect-all', 'false');
            // HideHeaderButtons(tableId);

            oTable.page(suggestion - 1).draw('page');
            let currentPage = oTable.page.info().page;

            // Enable page left/right
            $('.page-right').removeClass('disabled')
            $('.page-left').removeClass('disabled')

            // Disable page right/left if on last or first page
            if (currentPage === pages) { $('.page-right').addClass('disabled'); }
            if (currentPage === 1) { $('.page-left').addClass('disabled'); }

          });

          // On click of prev or next arrow
          $(tableContainer).find('.page-left').click(function() {
            let currentPage = oTable.page.info().page + 1;
            let pagination = $(this).closest('.pagination');

            // Enable page right
            $(pagination).find('.page-right').removeClass('disabled');

            // Remove hidden header buttons and preselect option
            $('#' + tableId).attr('data-preselect-all', 'false');
            // HideHeaderButtons(tableId);

            // Process if moving to first page or higher
            if (currentPage >= 2) {
              oTable.page('previous').draw('page');
              currentPage = oTable.page.info().page + 1;

              // Disable if at first page or moving to first page
              if (currentPage < 2) {  $(pagination).find('.page-left').addClass('disabled') } 

            }
          });

          // On click of prev or next arrow
          $(tableContainer).find('.page-right').click(function() {
            let currentPage = oTable.page.info().page + 1;
            let pagination = $(this).closest('.pagination');

            // Enable page left
            $(pagination).find('.page-left').removeClass('disabled');

            // Remove option to pre-select all 
            $('#' + tableId).attr('data-preselect-all', 'false');
            
            // Remove the option to remove selected
            $('.checkbox-minus').remove();

            // Process if moving to last page or lower
            if (currentPage < pages) {
              oTable.page('next').draw('page');
              currentPage = oTable.page.info().page + 1;

              // Disable if at last page or moving to last page
              if (currentPage >= pages) {  $(pagination).find('.page-right').addClass('disabled') }

            }

          });

          // Focus input
          $(tableContainer).find('.select-page-arrow').click(function() {
            let pagination = $(this).closest('.pagination');
            $(pagination).find('.pageSelect').typeahead('val','').focus();
          })

        }

      }
    });

    return 'rendered';
  }

  setUp(tableId) {

    // Set table
    let oTable = $('#' + tableId).DataTable();

    // Search table
    let timer;
    $('#search_' + tableId).keyup(function(){
      let val = $(this).val();
      clearTimeout(timer);
      timer = setTimeout(function() { oTable.search(val).draw() }, 800);
    });

    // Ensure search input starts blank
    $('#search_' + tableId).val('');

    // Set on click action for table rows
    AddRowClickLinks(tableId);

    return 'setup';

  }

};
